<template>
  <div class="container">
    <el-select
      v-model="year"
      style="width: 272px; margin-bottom: 8px"
      v-if="yearList"
      @change="getCLassCourse"
      size="small"
    >
      <el-option
        v-for="(year, index) in yearList"
        :value="year.value"
        :label="year.label"
        :key="index"
      />
    </el-select>
    <div>
      <el-radio-group v-model="subject" size="mini">
        <el-radio-button
          v-for="item in subjectList"
          :label="item.k"
          :key="item.k"
          >{{ item.v }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <div style="margin-top: 20px">
      <el-radio-group v-model="classId" size="mini" @input="onClassChange">
        <el-radio-button
          v-for="item in classList"
          v-if="item.subject === subject"
          :key="item.classId"
          :label="item.classId"
          >{{ item.className }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <div style="margin-top: 20px">
      <div class="paper-item" v-for="(paper, index) in paperList" :key="index">
        <span>{{ index + 1 }}、</span> <span>{{ paper.paperName }}</span>
        <el-button size="mini" @click="onStartExplain(paper)"
          >开始讲评</el-button
        >
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page.pageNum"
        :page-count="page.pageCount"
        :page-size="page.pageSize"
        :total="page.total"
        @current-change="getPaperList"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getGradeAndSubjects,
  getTeachClassCourse,
  getUserInfo,
} from "../apis/zhxApi";
import { getHomeworkList, getAllSubjectsApi } from "../apis/explainApi";
import { getToken } from "../utils/auth";

import App from "../App";

export default {
  name: "PaperList",
  components: { App },
  data() {
    return {
      subjectList: [],
      classList: [],
      subject: undefined,
      classId: undefined,
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageCount: 0,
      },
      paperList: [],
      token: undefined,
      year: undefined,
      yearList: undefined,
    };
  },
  created() {
    this.getAllSubjects();
    this.token = getToken();
    this.loginZhx();
  },
  methods: {
    loginZhx() {
      this.fetchUserInfo();
    },
    fetchUserInfo() {
      getUserInfo().then((res) => {
        this.year = res.data.schoolYear;
        this.computedYearList(this.year);
        this.getSubjectAndGrade();
      });
    },
    computedYearList(currentYear) {
      const defaultYearList = [
        { value: 2020, label: "2020-2021学年" },
        { value: 2021, label: "2021-2022学年" },
        { value: 2022, label: "2022-2023学年" },
        { value: 2023, label: "2023-2024学年" },
      ];
      let defaultYear = 2023;
      while (defaultYear < currentYear) {
        defaultYear += 1; // 增加年份
        defaultYearList.push({
          value: defaultYear,
          label: `${defaultYear}-${defaultYear + 1}学年`,
        });
      }
      this.yearList = defaultYearList.reverse();
    },
    getAllSubjects() {
      getAllSubjectsApi().then((response) => {
        if (response.data.subjects && response.data.subjects.length > 0) {
          this.constant.subjectMap = {};
          response.data.subjects.forEach((subject) => {
            this.constant.subjectMap[subject.type] = {
              k: subject.value,
              v: subject.text,
            };
          });
        }
      });
    },
    getSubjectAndGrade() {
      this.subject = undefined;
      this.classId = undefined;
      this.subjectList = [];
      this.classList = [];
      getGradeAndSubjects().then((response) => {
        console.log(response.data.subjects, "ppp");
        let subjectList = [];
        if (response.data.subjects && response.data.subjects.length > 0) {
          for (let i = 0; i < response.data.subjects.length; i++) {
            let subjectKey = response.data.subjects[i];
            if (this.constant.subjectMap[subjectKey] !== undefined) {
              subjectList.push(this.constant.subjectMap[subjectKey]);
            }
          }
        }
        this.subjectList = subjectList;

        if (
          this.subject === undefined &&
          this.subjectList &&
          this.subjectList.length > 0
        ) {
          this.subject = this.subjectList[0].k;
        }
        this.getCLassCourse();
      });
    },

    getCLassCourse() {
      this.classId = undefined;
      console.log(this.year, "this.year");
      getTeachClassCourse(this.year).then((response) => {
        console.log(response);
        this.classList = response.data.classCourseList;
        if (
          this.classId === undefined &&
          this.classList &&
          this.classList.length > 0
        ) {
          this.classId = this.classList[0].classId;
        }
        this.getPaperList();
      });
    },
    onClassChange(e) {
      console.log(e);
      this.pageNum = 1;
      this.getPaperList();
    },
    getPaperList() {
      getHomeworkList(
        this.subject,
        this.page.pageNum,
        this.page.pageSize,
        this.classId
      ).then((response) => {
        console.log(response);
        this.paperList = response.data.homeworkList;
        this.page.total = response.data.pagination.rowCount;
        this.page.pageCount = response.data.pagination.pageCount;
      });
    },
    onStartExplain(row) {
      console.log(row);
      this.$confirm("确认开始讲评: " + row.homeworkName + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let url =
            "/Explain/" +
            row.homeworkId +
            "/" +
            this.classId +
            "/" +
            this.token;
          const { href } = this.$router.resolve({
            path: url,
            query: {},
          });
          window.open(href, "_blank");
          // this.$router.push('/Explain/' + row.homeworkId + '/' + this.classId)
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px;
}

.paper-item {
  width: 100%;
  padding: 16px 16px;
  font-size: 14px;
  color: #606266;
  background-color: white;
}

.paper-item:hover {
  background-color: #fafafa;
}

.paper-index {
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/PaperList.vue